import {
    useMemo,
} from 'react'
import {
    ActionComponentsKey,
} from 'app/PoC/DataGridDemoPages/SkyNetObjectRoutes/SkyNetObjectRoutes.types'
import useAllowedActionKeys from '../../SkyNetObjectProfile/hooks/useAllowedActionKeys'
import {
    ExpandableActionComponents,
} from '../SkyNetDataGridExpandable.types'

const useAllowedActions = ({
    actionComponents,
}: Readonly<{
    actionComponents: ExpandableActionComponents
}>) => {
    const allowedActionKeys = useAllowedActionKeys({
        actionComponents,
    })

    return useMemo(() => {
        const actions: ExpandableActionComponents = {}

        Object.entries(actionComponents).forEach(([
            actionKey,
            value,
        ]) => {
            if (allowedActionKeys.includes(actionKey as ActionComponentsKey)) {
                actions[actionKey] = value
            }
        })
        return actions
    }, [
        actionComponents,
        allowedActionKeys,
    ])
}

export default useAllowedActions
